import { ActionMenu } from "@twinkltech/curriculum-architect-component-library";
import { Button, IconActionsMoreHoriz } from "@twinkltech/web-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router-dom";

import { PreviewUnitModalContainer } from "@/components/PreviewUnitModal/PreviewUnitModal.container";
import { TABLE_UNIT_CARD_NS } from "@/components/TableUnitCard/TableUnitCard.i18n";

import { paths } from "@/paths";
import { useFeedback } from "@/providers/Feedback/Feedback.context";

export const UnitDrawerCardActionMenu = ({
  curriculumId,
  resourceId,
  subjectId,
}: {
  curriculumId: string;
  subjectId: string;
  resourceId: string;
}) => {
  const { t } = useTranslation();
  const { incrementEngagementCount } = useFeedback();
  const [unitIdToPreview, setUnitIdToPreview] = useState<string | null>(null);
  return (
    <>
      <ActionMenu>
        <ActionMenu.Trigger
          aria-label="Open actions menu"
          className="border border-transparent hover:bg-neutral-100 rounded aria-expanded:bg-neutral-100"
        >
          <IconActionsMoreHoriz />
        </ActionMenu.Trigger>
        <ActionMenu.List className="p-2 bg-white list-none border rounded-lg border-neutral-150 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1)] z-30">
          {() => (
            <div
              aria-labelledby="adjust-schedule"
              className="flex flex-col gap-1 z-21"
              role="group"
            >
              <ActionMenu.StyledListItem className="border-none">
                <Button
                  className="rounded-md font-normal"
                  variant="ghost"
                  onClick={() => {
                    // open the preview modal by setting the unit ID to preview
                    setUnitIdToPreview(resourceId || null);
                  }}
                >
                  {t("preview-learning-sequence", { ns: TABLE_UNIT_CARD_NS })}
                </Button>
              </ActionMenu.StyledListItem>
              <ActionMenu.StyledListItem className="border-none">
                <Button
                  as={Link}
                  className="rounded-md font-normal"
                  to={generatePath(paths.SCHEME_LEARNING_SEQUENCE_PATH, {
                    curriculum_id: curriculumId,
                    subject_id: subjectId,
                    scheme_id: resourceId,
                    cell_id: "generic",
                  })}
                  variant="ghost"
                  onClick={() => {
                    incrementEngagementCount();
                  }}
                >
                  {t("view-learning-sequence", {
                    ns: TABLE_UNIT_CARD_NS,
                  })}
                </Button>
              </ActionMenu.StyledListItem>
            </div>
          )}
        </ActionMenu.List>
      </ActionMenu>
      {unitIdToPreview !== null && (
        <PreviewUnitModalContainer
          open={unitIdToPreview !== null}
          unitId={unitIdToPreview ?? ""}
          onClose={() => setUnitIdToPreview(null)}
        />
      )}
    </>
  );
};
